import { of as observableOf, Observable, Subject } from 'rxjs';

import { catchError, switchMap, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

//import 'rxjs/add/observable/of';
//import 'rxjs/add/operator/catch';
///import 'rxjs/add/operator/debounceTime';
//import 'rxjs/add/operator/distinctUntilChanged';

import { DocumentTypeService } from '../../../services/documents/document-type.service';
import { DocTemplateService } from '../../../services/documents/doc-template.service';

@Component({
  selector: 'app-doc-template-search',
  templateUrl: './doc-template-search.component.html',
  styleUrls: ['./doc-template-search.component.css'],
})
export class DocTemplateSearchComponent implements OnInit {
  @Input() autocomplete: boolean = true;
  @Input() by_document_type: boolean = false;
  @Input() list: boolean = false;
  @Input() matter_id: any;
  @Input() matter_info: any;

  docTemplateSearchTerm: string;
  documentTypeSearchTerm: string;

  documentTypes: Array<any> = [];

  searchDocumentTypeTerms = new Subject<string>();

  prevDocTemplateItem: any;

  @Input() docTemplateItem: any;
  @Input() small_input: boolean;
  @Output() docTemplateSelection: EventEmitter<string> = new EventEmitter();

  constructor(private documentTypeService: DocumentTypeService, private docTemplateService: DocTemplateService) {}

  ngOnInit() {
    this.searchDocumentTypeTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((term) => {
          if (term) {
            return this.docTemplateService.fieldSearchDocumentType(term, this.matter_id);
          } else {
            return observableOf<any>([]);
          }
        }),
        catchError((error) => {
          console.log(error);
          return observableOf<any>([]);
        })
      )
      .subscribe((data) => {
        this.documentTypes = data;
      });
  }

  clearSelectedDocTemplate(): void {
    this.docTemplateItem = undefined;
    this.docTemplateSearchTerm = '';
    this.documentTypeSearchTerm = '';
  }

  docTemplateSearchOnSelect(item: any): void {
    this.docTemplateItem = item;
    this.docTemplateSelection.emit(item);
    this.documentTypeSearchTerm = this.docTemplateItem.document_type_name;
    this.docTemplateSearchTerm = this.docTemplateItem.label;
  }

  docTemplateSelect(item: any): void {
    this.docTemplateItem = item;
    this.documentTypeSearchTerm = this.docTemplateItem.document_type_name;
    this.docTemplateSearchTerm = this.docTemplateItem.label;
  }

  selectTemplate(documentType: any, docTemplate: any): void {
    this.docTemplateItem = docTemplate;
    this.docTemplateSelection.emit(docTemplate);
    this.documentTypes = [];
    this.documentTypeSearchTerm = this.docTemplateItem.document_type_name;
    this.docTemplateSearchTerm = this.docTemplateItem.label;
  }

  fieldSearchDocumentType(term: string): void {
    this.documentTypeSearchTerm = term;
    this.searchDocumentTypeTerms.next(term);
  }

  expandDocumentType(documentType: any) {
    if (!documentType.expanded) {
      documentType.expanded = true;
      this.documentTypeService.fetchTemplates(documentType.id, this.documentTypeSearchTerm, this.matter_info.matter_type_id).then((response_json) => {
        documentType.templates = response_json.document_type_templates;
        documentType.others = response_json.others;
      });
    } else documentType.expanded = false;
  }
}
